<ng-template #modal>
  <div class="modal__container">
    <div class="modal__superior">
      {{titulo}}
      <img class="modal__superior__img" src="../../../assets/images/simbolos/closeIcon.svg" alt="ícone de x"
        (click)="closeModal();">
    </div>
    <div class="modal__group">
      <div class="modal__conteudo">
        <p *ngIf="showOrHideMessage">{{mensagem}}</p>
        <ng-content></ng-content>
      </div>

      <div class="modal__buttons" *ngIf="showOrHideButton">
        <button (click)="pressButton()"
          style="background-color: {{bgColor}}; color: {{color}}; border:  1px solid {{border}};">
          {{botao}}
        </button>
      </div>
    </div>
  </div>
</ng-template>